import React, { useState } from "react";
import styled from "styled-components";
import colors from "../constatns/colors";
import useWindowDimensions from "../constatns/size";

import "../styles/home.css";
function EccosystemCard({image, title, description, id}) {
    const { width, height } = useWindowDimensions();
  return (
    <Container width={width} height={height} id={id}>
        <InnerContainer>
            <CardImage alt={image} src={image} />
        </InnerContainer>
        <Title >{title}</Title>
        <Description>{description}</Description>
    </Container>
  );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #1F2450;
    padding: 20px;
    width: ${({width})=> width * 0.15}px;
    height: ${({height})=> height * 0.4}px;
    border-radius: 10px;
    margin-top: 20px;
    margin-left: 20px;
    align-items: center;
    /* justify-content: center; */
    @media (max-width: 1068px) {
        padding: 10px;
        margin-right: 10px;
    }

    @media (max-width: 768px) {
        width: ${({width})=> width * 0.8}px;
        height: ${({height})=> height * 0.3}px;
        margin-left: ${({width})=> width * 0.05}px;
        margin-right: ${({width})=> width * 0.05}px;
    }
`

const InnerContainer = styled.div`
    display: flex;
    width: 60px;
    height: 60px;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 30px;
    background-color: ${colors.btnPrimary};

    @media (max-width: 1068px) and (min-width: 769px) {
        width: 45px;
        height: 45px;
        margin-top: 0px;
        border-radius: 22.5px;
    }

    /* @media (max-width: 768px) {
        width: 45px;
        height: 45px;
        margin-top: 0px;
        border-radius: 22.5px;
    } */
`

const CardImage = styled.img`
    width: 35px;
    height: 35px;
    @media (max-width: 1068px) and (min-width: 769px) {
        width: 20px;
        height: 20px;
    }

    @media (max-width: 768px) {
        
    }
`

const Title = styled.h4`
    color: ${colors.white}; 
    text-align: center;
    margin: 0; 
    height: 10;
    height: 45px;
    @media (max-width: 1068px) {
        /* height: 20; */
        font-size: 13px;
    }

    @media (max-width: 768px) {
        font-size: 24px;
    }
`

const Description = styled.p`
    color: ${colors.grey};
    text-align: center;
    margin: 0px;
    @media (max-width: 1068px) {
        font-size: 12px;
    }

    @media (max-width: 768px) {
        font-size: 16px;
    }
`

export default EccosystemCard;
